import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

const LinkedInCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // ✅ Extract query params
        const params = new URLSearchParams(location.search);
        const code = params.get("code");
        const state = params.get("state");

        if (!code || !state) {
          console.error("Missing code/state");
          return;
        }

        console.log("Code:", code);
        console.log("State:", state);
        alert(localStorage.getItem("user_email"));
        let email = localStorage.getItem("user_email");

        //  Call your backend API
       const { data } = await axios.get(
            `${apiUrl}/api/socialmedia/auth/linkedin/callback`,
            {
                params: {
                code,
                state,
                user_email: email   
                }
            }
        );

        console.log("Callback success:", data);

        //  Redirect after success
        navigate("/codegenie/generated-blogs");

      } catch (error) {
        console.error("LinkedIn callback error:", error);

        // optional: redirect to error page
        navigate("/error");
      }
    };

    handleCallback();
  }, [location]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h3>Connecting to LinkedIn...</h3>
      <p>Please wait...</p>
    </div>
  );
};

export default LinkedInCallback;